import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'propertyType' })
export class PropertyType implements PipeTransform {
  transform(text: string) {
    let options = {
      single_family: 'Single Family',
      singlefamily: 'Single Family',
      'single family': 'Single Family',
      'single family residential': 'Single Family',
      single_ramily_residential: 'Single Family',
      multi_family: 'Multi Family',
      multifamily: 'Multi Family',
      'multi family': 'Multi Family',
      'condo/co-op': 'Condo',
      'condo/coop': 'Condo',
      condos: 'Condo',
      townhouse: 'Townhouse',
      other: 'other',
    };
    if (text && options[text.toLowerCase()]) {
      return options[text.toLowerCase()];
    }
    return 'Unknown';
  }
}
